import ModalNewGroup from "./ModalNewGroup";
import ModalSelectClient from "./ModalSelectClient";
import ModalEditUser from "./ModalEditUser";
import ModalNewUser from "./ModalNewUser";
import ModalChangePassword from "./ModalChangePassword";
import ModalUserPermissions from "./ModalUserPermissions";
import ModalEditGroup from "./ModalEditGroup";
import ModalDeleteGroup from "./ModalDeleteGroup";

function UserModals({
  activeModal,
  setActiveModal,
  showModal,
  handleSelectClient, // ✅ Cambiato da handleSelectGroup
  handleCloseModal,
  selectedClient, // ✅ Cambiato da selectedGroup
  setSelectedClient, // ✅ Cambiato da setSelectedGroup
  availableClients, // ✅ AGGIUNGI QUESTA PROP
  editUser,
  setEditUser,
  editGroup,
  setEditGroup,
  groupToDelete,
  setGroupToDelete,
  groups,
  adminUser,
  allUsersCached,
  setAllUsersCached,
  setAllGroupsCached,
  handleUpdateUser,
  handleCreateUser,
  handleUpdateGroup,
  handleDeleteGroup,
  setGroups,
  setUsers,
  hasManagementPermissions,
  selectedClientCode,
}) {
  return (
    <>
      {showModal && (
        <ModalSelectClient
          clients={availableClients} // ✅ Passa availableClients
          selectedClient={selectedClient}
          setSelectedClient={setSelectedClient}
          onSelect={handleSelectClient}
          onClose={handleCloseModal}
        />
      )}

      {activeModal === "newGroup" && (
        <ModalNewGroup
          selectedClientCode={selectedClientCode }
          setGroups={setGroups}
          setUsers={setUsers}
          onClose={() => setActiveModal(null)}
          availableMembers={allUsersCached.map((u) => u.USER)}
          adminUser={adminUser}
          setAllUsersCached={setAllUsersCached}
          setAllGroupsCached={setAllGroupsCached}
        />
      )}
      {activeModal === "newUser" && (
        <ModalNewUser
          groups={groups.map((g) => g.GRUPO || g.NOMBRE)}
          clients={adminUser?.CLIENTES_ASOCIADOS || []}
          defaultClient={adminUser?.COD_CLIENTE || ""}
          onClose={() => setActiveModal(null)}
          onCreate={handleCreateUser}
        />
      )}
      {activeModal === "editUser" && editUser && (
        <ModalEditUser
          user={editUser}
          allGroups={groups.map((g) => g.GRUPO || g.NOMBRE)}
          onClose={() => {
            setEditUser(null);
            setActiveModal(null);
          }}
          onSave={handleUpdateUser}
          hasManagementPermissions={hasManagementPermissions}
        />
      )}

      {activeModal === "changePassword" && editUser && (
        <ModalChangePassword
          user={editUser}
          allGroups={groups.map((g) => g.GRUPO || g.NOMBRE)}
          onClose={() => {
            setEditUser(null);
            setActiveModal(null);
          }}
          onSave={handleUpdateUser}
          hasManagementPermissions={hasManagementPermissions}
        />
      )}

      {activeModal === "permissions" && editUser && (
        <ModalUserPermissions
          user={editUser}
          allGroups={groups.map((g) => g.GRUPO || g.NOMBRE)}
          selectedClientCode={selectedClientCode}
          onClose={() => {
            setEditUser(null);
            setActiveModal(null);
          }}
          onSave={handleUpdateUser}
        />
      )}

      {activeModal === "editGroup" && editGroup && (
        <ModalEditGroup
          group={editGroup}
          onClose={() => {
            setEditGroup(null);
            setActiveModal(null);
          }}
          onSave={handleUpdateGroup}
        />
      )}

      {activeModal === "deleteGroup" && groupToDelete && (
        <ModalDeleteGroup
          group={groupToDelete}
          onClose={() => {
            setGroupToDelete(null);
            setActiveModal(null);
          }}
          onConfirm={handleDeleteGroup}
        />
        )}
    </>
  );
}

export default UserModals;
